import { useEffect } from 'react'
import { useBlocker, useTranslate } from 'react-admin'

/**
 * Asks before leaving a page whose work would be lost — in the app (menu,
 * links, back) and on closing or reloading the tab. react-admin's forms do
 * this for unsaved changes; a page that is no form (the photo page) needs it
 * too: photos prepared there and not saved were gone without a word.
 */
export const useWarnBeforeLeaving = (unsaved: boolean, message: string) => {
  const translate = useTranslate()
  const blocker = useBlocker(
    ({ currentLocation, nextLocation }) =>
      unsaved && currentLocation.pathname !== nextLocation.pathname
  )

  useEffect(() => {
    if (blocker.state !== 'blocked') return
    if (!unsaved || window.confirm(translate(message))) blocker.proceed?.()
    else blocker.reset?.()
    // The blocker object is not stable across renders.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [blocker.state])

  useEffect(() => {
    if (!unsaved) return
    const beforeunload = (e: BeforeUnloadEvent) => {
      // The browser shows its own question; the text cannot be chosen.
      e.preventDefault()
      e.returnValue = true
    }
    window.addEventListener('beforeunload', beforeunload)
    return () => window.removeEventListener('beforeunload', beforeunload)
  }, [unsaved])
}
